const key = "53eabb20f689c49327591baa777dfbe0";

export default key;